require('./vms.module.js');
require('./vms.route.js');

require('./assessment_histories');
require('./assessment_questions');
require('./assessments');
require('./assignments');
require('./branches');
require('./constants');
require('./contracts');
require('./custom_field_definitions');
require('./departments');
require('./document_requirements');
require('./layouts');
require('./my_fi');
require('./notifications');
require('./notification_settings');
require('./products');
require('./reports');
require('./services');
require('./templates');
require('./user_audits');
require('./vendors');
require('./vendor_management_policies');
require('./vendor_update_requests');
